import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";
import persistedUserReducer from "./slices/userSlice";
import { configurationApis } from "./apis/configurationApis";

// Import the API slice
import { userApi } from "./apis/userApi";
import { headerApi } from "./apis/headerApi";
import { centerApis } from "./apis/centerApis";
import { reportApi } from "./apis/reportsApis";
import { targetApis } from "./apis/targetApis";
import { dashboardApis } from "./apis/dashboardApis";
import { leaderboardApi } from "./apis/leaderboardApi";

const store = configureStore({
  reducer: {
    user: persistedUserReducer,
    [userApi.reducerPath]: userApi.reducer,
    [headerApi.reducerPath]: headerApi.reducer,
    [centerApis.reducerPath]: centerApis.reducer,
    [configurationApis.reducerPath]: configurationApis.reducer,
    [reportApi.reducerPath]: reportApi.reducer,
    [targetApis.reducerPath]: targetApis.reducer,
    [dashboardApis.reducerPath]: dashboardApis.reducer,
    [leaderboardApi.reducerPath]: leaderboardApi.reducer,
  },

  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(
      userApi.middleware,
      headerApi.middleware,
      centerApis.middleware,
      configurationApis.middleware,
      reportApi.middleware,
      targetApis.middleware,
      dashboardApis.middleware,
      leaderboardApi.middleware
    ), // Add the API middleware
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
